import axios from "axios";
import store from "./store";
import { USER_LOGOUT } from "./constants/userConstants";

function logout() {
  localStorage.removeItem("userInfo");
  store.dispatch({ type: USER_LOGOUT });
  if (!window.location.hash.startsWith("#/login")) {
    window.location.href = "/#/login";
  }
}

function tokenExpiresAt(token) {
  if (!token) {
    return null;
  }
  try {
    const segment = token.split(".")[1];
    const json = atob(segment.replace(/-/g, "+").replace(/_/g, "/"));
    const payload = JSON.parse(json);
    return typeof payload.exp === "number" ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

let logoutTimer = null;
let watchedToken = undefined;

function watchSession(token) {
  if (token === watchedToken) {
    return;
  }
  watchedToken = token || null;
  clearTimeout(logoutTimer);
  logoutTimer = null;
  const expiresAt = tokenExpiresAt(token);
  if (!expiresAt) {
    return;
  }
  const delay = expiresAt - Date.now();
  if (delay <= 0) {
    logout();
    return;
  }
  logoutTimer = setTimeout(logout, delay);
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !url.includes("/api/users/login/")) {
      logout();
    }
    return Promise.reject(error);
  }
);

store.subscribe(() => {
  watchSession(store.getState().userLogin.userInfo?.token);
});

watchSession(store.getState().userLogin.userInfo?.token);

export default axios;
